document.addEventListener('DOMContentLoaded', function () {
  
  /***
  Back to top
  **/
  var backToTopButton = document.getElementById('backToTop');
  window.addEventListener('scroll', function () {
    if (window.scrollY > 300) {
      backToTopButton.style.display = 'block';
    } else {
      backToTopButton.style.display = 'none';
    }
  });

  backToTopButton.addEventListener('click', function () {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  });
  /***
  end Back to top
  **/
  
  
  /***
  Menu hide/show upon cookie brand
  **/
  var brandSelect2 = getCookie('brandSelect');
  if (brandSelect2) {
    var brandDataJson2 = JSON.parse(brandSelect2);
    const navElements2 = document.querySelectorAll('.brand-data');
    navElements2.forEach(nav => {
      if (nav.getAttribute('data-load-brand') === brandDataJson2.brandLink) {
        nav.style.display = 'block'; // Show landing-1
      } else {
        nav.style.display = 'none'; // Hide other navs
      }
    });
  }
  /***
  end Menu hide/show upon cookie brand
  **/

  /***
  sticky menu custom work
  **/
  let lastScrollTop = 0;
  const body = document.querySelector('body');
  const brandHeader = document.querySelector('.brand-header-section');

  window.addEventListener('scroll', () => {
      const currentScroll = window.scrollY;
      if (currentScroll > 300) {
        if (currentScroll > lastScrollTop) {
            // Scrolling down
            body.classList.remove('sticky-menu-brand'); 
            body.classList.add('sticky-menu-only'); 
        } else {
            // Scrolling up
            body.classList.add('sticky-menu-brand'); 
            body.classList.remove('sticky-menu-only'); 
        }
      }
    else{
        body.classList.remove('sticky-menu-brand'); 
        body.classList.remove('sticky-menu-only'); 
    }

      lastScrollTop = currentScroll <= 0 ? 0 : currentScroll; // Avoid negative scroll values
  });
  /***
  end sticky menu custom work
  **/
  
  /***
  Product list change variant info
  **/
  document.querySelectorAll('.grid-item').forEach((productItem) => {
      const priceElement = productItem.querySelector('.grid-product__price');
      const nameElement = productItem.querySelector('.grid-product__title');
      const swatches = productItem.querySelectorAll('color-swatches .color-swatch');
      if (priceElement) {
          priceElement.dataset.originalHtml = priceElement.innerHTML;
      }
      if (nameElement) {
          nameElement.dataset.originalHtml = nameElement.innerHTML;
      }
      swatches.forEach((swatch) => {
          swatch.addEventListener('mouseover', () => {
              const newPrice = swatch.dataset.price; 
              const newTitle = swatch.dataset.variantName;
  
              const newPriceHtml = `
                <span class="grid-product__price--current">
                    <span aria-hidden="true">
                        ${swatch.dataset.price}
                    </span>
            `;

            if (priceElement) {
                priceElement.innerHTML = newPriceHtml;
            }
              if (nameElement) {
                  nameElement.textContent = `${newTitle}`;
              }
          });
  
          swatch.addEventListener('mouseout', () => {
              if (priceElement) {
                priceElement.innerHTML = priceElement.dataset.originalHtml;
            }
            if (nameElement) {
                nameElement.innerHTML = nameElement.dataset.originalHtml;
            }
          });
      });
  });
  /***
  end Product list change variant info
  **/
  
  document.addEventListener("click", function (e) {
    const wpContainer = document.querySelector(".wa__widget_container");
    if (wpContainer && !wpContainer.contains(e.target) && document.querySelector(".wa__widget_container .wa__btn_popup.wa__active")) {
      document.querySelector(".wa__widget_container .wa__btn_popup.wa__active").click();
    }
  });
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape" && document.querySelector(".wa__widget_container .wa__btn_popup.wa__active")) { 
    document.querySelector(".wa__widget_container .wa__btn_popup.wa__active").click();
    }
  });
});
document.addEventListener("DOMContentLoaded", function () {
  const passwordInput = document.querySelector(".show_password_input");
  const toggleButton = document.querySelector(".show_password");

  if(passwordInput  && toggleButton)
  {
    toggleButton.addEventListener("click", function () {
        const isPassword = passwordInput.getAttribute("type") === "password";
        passwordInput.setAttribute("type", isPassword ? "text" : "password");
    });
  }

  setTimeout(() => {
    let inputField = document.querySelector('.cl-po--dimension-item [name="properties[_Area_x]"]');

    if (inputField) {
      inputField.addEventListener("blur", function () {
        let current_value_x = this.value;
        if(current_value_x > 1000)
        {
            // Round up to the nearest 100 mm
            var roundedValue_x = Math.ceil(current_value_x / 100) * 100;
            //console.log(roundedValue_x);
            this.value = roundedValue_x;
            this.dispatchEvent(new Event("input", { bubbles: true }));
            this.dispatchEvent(new Event("change", { bubbles: true }));
        }
      });
    }
  }, 2000);
});
